import { PortalBPSubMenuList } from '../list';

export class FormView extends PortalBPSubMenuList {
  name = 'form-view';
}